import type { Tutorial } from '../types'

const IMG = '/images/tutorials/web/profile-sharing'

export const profileSharingWebTutorial: Tutorial = {
  slug: 'profile-sharing',
  platform: 'web',
  title: 'Profile Sharing',
  subtitle: 'Granular sharing from the profile manager',
  date: '2026-07-09',
  category: 'Sharing & Support',
  tags: ['Profile Sharing', 'collaborators', 'permissions'],
  description:
    'Share a profile from /profiles/share/:id with per-category permissions, expiration, and a confirmation step before anything is sent.',
  highlights: [
    'Choose exactly which categories to share — Goals, Records, Coach, genetics reports.',
    'Set access expiration before sending the invite.',
    'Recipients must accept before seeing anything; revoke any time.',
  ],
  coverImage: `${IMG}/01-share-form.png`,
  sections: [
    {
      heading: 'The share form',
      paragraphs: [
        'From **All Profiles**, open a profile\'s share page. Enter the recipient\'s email, relationship, optional note, and toggle each data category independently. Documents are never included in sharing.',
        'An expiration control lets you time-box access — 7/30/90 days, one year, or no expiration.',
      ],
      image: {
        src: `${IMG}/01-share-form.png`,
        alt: 'Profile sharing form on Livewello web',
        caption: 'Share profile form',
      },
    },
  ],
  whyMatters:
    'Web sharing uses the same granular permissions as mobile but with more screen space to review every category before sending — important when sharing with a clinician or family member.',
  relatedSlugs: ['multi-profile', 'accountability-partner-workflow'],
  meta: {
    description: 'Profile Sharing on Livewello web: per-category permissions and time-boxed access.',
    ogImage: `${IMG}/01-share-form.png`,
  },
}
